import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "flex items-center gap-4" }
const _hoisted_3 = { class: "text-xl font-medium" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Balance used for international calling, sms messages, outbound physical mailing and fax/virtual mailing overage pages usage. ", -1)

import { ref } from 'vue';
import { UiButton, SvgIcon } from '@/ui-kit';
import MakePaymentDialog from '../components/MakePaymentDialog.vue';
import { useCompanyProfile } from '@/account';


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionBalance',
  setup(__props) {

const { balance } = useCompanyProfile();

const makePaymentDialogRef =
	ref<InstanceType<typeof MakePaymentDialog>>();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, " Balance: " + _toDisplayString(_unref(balance)), 1),
        _createVNode(_unref(UiButton), {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (makePaymentDialogRef.value?.openDialog())),
          class: "!text-sm !h-8 !min-w-20 w-32 !px-0",
          theme: "primary-outlined"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(SvgIcon), {
              class: "h-4 w-4 mr-2",
              name: "plus"
            }),
            _createTextVNode("Add money ")
          ]),
          _: 1
        })
      ]),
      _hoisted_4
    ]),
    _createVNode(MakePaymentDialog, {
      ref_key: "makePaymentDialogRef",
      ref: makePaymentDialogRef
    }, null, 512)
  ], 64))
}
}

})